import locale from "localization/en";

export const detailedTransactionHistoryColumn = [
  { key: "stationCode", text: locale.stationCode },
  {
    key: "shiftDateAndTime",
    text: locale.shiftDateandTime,
    style: {
      width: "auto",
      minWidth: "150px",
    },
  },
  {
    key: "salesInvoiceNumber",
    text: locale.salesInvoiceNumber,
    style: {
      width: "auto",
      minWidth: "150px",
    },
  },
  {
    key: "transactionDateAndTime",
    text: locale.transactionDateAndTime,
    style: {
      width: "auto",
      minWidth: "150px",
    },
  },
  { key: "paymentMethod", text: locale.paymentMethod },
  {
    key: "paymentReferenceNumberAndName",
    text: locale.paymentReferenceNumberAndName,
    style: {
      width: "auto",
      minWidth: "120px",
    },
  },
  { key: "productType", text: locale.productType },
  {
    key: "productName",
    text: locale.productName,
    style: {
      width: "auto",
      minWidth: "120px",
    },
  },
  { key: "productDetails", text: locale.productDetails },
  { key: "quantity", text: locale.quantity },
  { key: "totalizerReading", text: locale.totalizerReading },
  {
    key: "pricePerItem",
    text: locale.pricePerItem,
    style: {
      width: "auto",
      minWidth: "100px",
    },
  },
  {
    key: "totalGrossAmount",
    text: locale.totalGrossAmount,
    style: {
      width: "auto",
      minWidth: "100px",
    },
  },
  {
    key: "totalDiscount",
    text: locale.totalDiscount,
    style: {
      width: "auto",
      minWidth: "100px",
    },
  },
  {
    key: "totalAmountDue",
    text: locale.totalAmountDue,
    style: {
      width: "auto",
      minWidth: "100px",
    },
  },
];
